import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { CoreLoadingScreenService } from '@core/services/loading-screen.service';
import { NotificationService } from '@shared/services';
import { AuthenticationService } from 'app/main/auth/service';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _notificationService: NotificationService,
    private _spinner: CoreLoadingScreenService,
    private _authService: AuthenticationService,
    private _toastr: ToastrService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        this._spinner.hide();
        this.checkHttpStatus(err);
        return throwError(err);
      })
    );
  }

  private checkHttpStatus(err: HttpErrorResponse): void {

    switch (err.status) {
      case 400:
        //    this._authService.checkStatusAvailability();
        break;
      case 403:
        this._notificationService.error('You are not authorized', this.getErrorMessages(err));
        break;
      case 422:
        break;
      //   case 0:
      case 401:
      case 402:
        this._authService.logout();
        break;
      case 404:
        this._notificationService.error('Not Found', this.getErrorMessages(err));
        break;
      case 500:
        this._notificationService.error('Invalid Info', this.getErrorMessages(err));
        break;
      default:
        this._notificationService.error('Something went wrong', this.getErrorMessages(err));
        break;
    }
  }

  private getErrorMessages(err: HttpErrorResponse): string {
    let err3 = err?.error?.detail;

    let errors = err?.error?.length > 0 ? err?.error?.map((x: any) => x?.message) : null;

    let err1 = err?.error ? errors?.join(', ') : null;

    let err2 = err?.error?.errors;

    let err4 = typeof err?.error == 'string' ? err?.error : null;

    let err5 = `Seems like something went wrong. please contact your administrator`;

    return err1 || err2 || err3 || err4 || err5;
  }

  checkPassword(err: any) {
    //  this._authService.checkStatusAvailability();
  }
}
